export default "__VITE_ASSET__CsZYgo6X__"